<template>
    <g :id="`room${metadata.id}`" :class="{ 'room': true, 'active': objectMode == 2 }">
        <!--<rect  :x="data.x" :y="data.y" :width="data.width" :height="data.height" rx="10" stroke="#FF8A00" style="stroke-width:3px" fill="#FFF5E5"></rect>-->
        <foreignObject class="room-area" :x="absolutePos.x-10" :y="absolutePos.y-10" :width="metadata.width+20" :height="metadata.height+30"  @mousedown="startDrag" @touchstart="startDrag">
            <div></div>
        </foreignObject>
        <foreignObject class="room-header" :x="absolutePos.x" :y="absolutePos.y-30" :width="metadata.width" :height="30"><span class="room-name noselect">
            <span :style="{
                'visibility': objectMode == 2 ? 'visible' : 'visible',
                'position': objectMode == 2 ? 'absolute' : 'inherit'
            }"><span ref="titleText">{{ metadata.name }}</span></span>
            <input :style="{
                'display': objectMode == 2 ? 'block' : 'none',
                'width': `${textWidth+5}px`
            }" v-model="metadata.name" @input="test" placeholder="Untitled Room" />
        </span></foreignObject>
    </g>
</template>

<script>
import { mapGetters } from "vuex";
import { angle, distance, getSVGCoordinates, calculateRelativePosition, getItemByValue, exportRoomAsImage, downloadDataURL } from "@/utils";

let dragging = {
    id: null,
    start: {
        mouse: null,
        pos: null
    }
}

export default {
    name: "Room",
    props: ['metadata'],
	computed: {
        ...mapGetters(['objectMode', 'getSelf', 'getRooms', 'getObjects']),
        absolutePos() {
            return calculateRelativePosition(this.metadata, this.getRooms);
        },
        textWidth() {
            let text = this.metadata.name;
            if('titleText' in this.$refs) {
                this.$refs.titleText.textContent = this.metadata.name;
                return this.$refs.titleText.offsetWidth;
            } else {
                return 105;
            }
            
        }
    },
    mounted() {
        window.addEventListener('mousemove', this.mouseMove);
        window.addEventListener('touchmove', this.mouseMove);
        window.addEventListener('mouseup', this.endDrag);
        window.addEventListener('touchend', this.endDrag);

        window.addEventListener('keyup', this.keyUp);
    },
    methods: {
        test() {
            this.$store.dispatch('updateRoomProps', [
                { id: this.metadata.id, prop: 'name', value: this.metadata.name },
            ])
        },
        keyUp(e) {
            // console.log(e.keyCode);
            if(e.keyCode === 220) {
                let room = this.metadata;
                let roomPos = calculateRelativePosition(room, this.getRooms);

                if(this.getSelf.x > roomPos.x && this.getSelf.x < roomPos.x + room.width && this.getSelf.y > roomPos.y && this.getSelf.y < roomPos.y + room.height) {
                    let objectsWithin = this.getObjects.filter(x => x.in == this.metadata.id);
                    
                    let data = {
                        rooms: [
                            {
                                width: this.metadata.width,
                                height: this.metadata.height
                            }
                        ],
                        objects: objectsWithin.map(object => {
                            let out = Object.assign({}, object);
                            delete out.x
                            delete out.y
                            delete out.icon
                            out.in = 0

                            return out
                        })
                    }

                    downloadDataURL("data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(data)), `${this.metadata.name}.json`);

                    exportRoomAsImage(room, objectsWithin);
                }
            }
        },
        mouseMove(e) {
            if(dragging.id === this.metadata.id) {
                //this.dragging = true;

                let leftMouseButtonOnlyDown = (e.buttons === undefined ? e.which === 1 : e.buttons === 1) || e.touches != undefined;

                // if user right clicks or gets stuck in dragging, this fixes it
                if(!leftMouseButtonOnlyDown) {
                    this.endDrag();
                    return;
                }

                var cursorpt = getSVGCoordinates(e);

                if(dragging.start.mouse == undefined) {
                    dragging.start.pos = {x: this.absolutePos.x, y: this.absolutePos.y }
                    dragging.start.mouse = cursorpt;
                } else {
                    let absoluteX = cursorpt.x - dragging.start.mouse.x + dragging.start.pos.x;
                    let absoluteY = cursorpt.y - dragging.start.mouse.y + dragging.start.pos.y;
                    this.$store.dispatch('updateRoomProps', [
                        { id: this.metadata.id, prop: 'x', value: absoluteX },
                        { id: this.metadata.id, prop: 'y', value: absoluteY  },
                        { id: this.metadata.id, prop: 'z_index', value: Date.now() }
                    ]);

                    let inside, insidePos;
                    //let metadata = this.metadata;
                    this.getRooms.filter(x => x.id != this.metadata.id).forEach(room => {
                        let roomPos = calculateRelativePosition(room, this.getRooms);

                        if(absoluteX > roomPos.x && absoluteX + this.metadata.width < roomPos.x + room.width && absoluteY > roomPos.y && absoluteY + this.metadata.height < roomPos.y + room.height) {
                            inside = room.id;
                            insidePos = roomPos;
                        }
                    });

                    if(inside != undefined) {
                        let relativeX = absoluteX - insidePos.x;
                        let relativeY = absoluteY - insidePos.y;
                        this.$store.dispatch('updateRoomProps', [
                            { id: this.metadata.id, prop: 'relx', value: relativeX },
                            { id: this.metadata.id, prop: 'rely', value: relativeY  },
                            { id: this.metadata.id, prop: 'in', value: inside }
                        ]);
                    } else {
                        this.$store.dispatch('updateRoomProps', [
                            { id: this.metadata.id, prop: 'relx', value: null },
                            { id: this.metadata.id, prop: 'rely', value: null  },
                            { id: this.metadata.id, prop: 'in', value: null }
                        ]);
                    }
                    

                    let pointerAngle = angle(this.getSelf, cursorpt);
                    let pointerDistance = distance(this.getSelf, cursorpt);
                    
                    this.$store.dispatch('updatePointer', {
                        type: 'hold',
                        distance: pointerDistance,
                        angle: pointerAngle
                    });
                }
            } else {
                this.dragging = false;
            }
            
        },
        startDrag(e) {
            if(this.objectMode != 2) return;

            dragging.id = this.metadata.id;

            this.$store.dispatch('updateRoomProps', [
                { id: this.metadata.id, prop: 'dragging', value: true }
            ]);

            e.preventDefault();
            return false
        },
        endDrag() {
            if(dragging.id === this.metadata.id) {
                dragging.id = null;
                this.$store.dispatch('updatePointer', null);

                this.$store.dispatch('updateRoomProps', [
                    { id: this.metadata.id, prop: 'dragging', value: false }
                ]);

                dragging.start.pos = null;
                dragging.start.mouse = null;
            }

        },
    }
};
</script>

<style>
    .room.active .room-area {
        cursor: move;
    }
    .room-area {
        padding: 10px;
    }
    .room-area > div {
        width: calc(100% - 20px);
        height: calc(100% - 30px);

        border-radius: 10px;
        border: 3px solid #FF8A00;
        background: #FFF5E5;
        box-shadow: 0px 5px 10px rgba(0,0,0,0.2);

        transition: all .1s ease-out;
    }
    .room.active .room-area:hover > div {
        background: rgb(255, 235, 212);
    }

    .room-header {
		white-space: nowrap;
		color: #FF8A00;
		padding-left: 8px;
	}
	.room-name {
		font-weight: bold;
		font-size: 17px;
    }
    .room-name > span {
        display: inline-block;
        padding: 4px 10px;
        white-space: pre;
        pointer-events: none;
        z-index:-1;
    }
    .room-name input {
        font-weight: bold;
        font-size: 17px;
        color: #FF8A00;
        padding: 0;
        border: none;
        background: none;
        outline: none;
        background: #ff880021;
        font-family: "Roboto Condensed", sans-serif;
        padding: 3px 4px 2px 9px;
        border-radius: 7px;
        border: 1px solid transparent;
        transition: .13s all ease-out;
        white-space: nowrap;
        overflow: hidden;

        color: transparent;
        caret-color: #FF8A00;
    }
    .room-name input:hover {
        background: #ff880048;
    }
    .room-name input:placeholder-shown {
        width: 100px !important;
    }
    .room-name input::placeholder {
        color: #ff880080;
    }
    .room-name input::selection {
        color: #FFFFFF;
        background-color: #FF8A00;
    }
</style>